import { RdfXmlParser } from "rdfxml-streaming-parser";
export function parseRdfXml(content) {
    const parser = new RdfXmlParser();
    return new Promise((resolve, reject) => {
        const quads = [];
        parser.on('data', quad => quads.push(quad));
        parser.on('end', () => resolve(quads));
        parser.on('error', error => reject(error));
        parser.write(content);
        parser.end();
    });
}
//# sourceMappingURL=rdfxml-adapter.js.map